import type { SubmitRequest, SubmitResponse, ConfirmRequest, ConfirmResponse } from '@/types';

const TAG = '[mocy-revocation]';

const getConfig = () => {
	const data = typeof window !== 'undefined' ? window.mocyRevocationData : undefined;
	if (!data || !data.restUrl) {
		console.error(TAG, 'missing_config: window.mocyRevocationData fehlt oder restUrl leer', data);
		throw new Error('missing_config');
	}
	return data;
};

const buildUrl = (base: string, pathname: string): string => {
	const trimmed = base.replace(/\/+$/, '');
	const suffix = pathname.replace(/^\/+/, '');
	return `${trimmed}/${suffix}`;
};

async function request<T>(pathname: string, body: unknown): Promise<T> {
	const { restUrl, nonce } = getConfig();
	const url = buildUrl(restUrl, pathname);

	let response: Response;
	try {
		response = await fetch(url, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'X-WP-Nonce': nonce || '',
			},
			body: JSON.stringify(body ?? {}),
		});
	} catch (networkError) {
		console.error(TAG, 'network_error', networkError);
		throw new Error('network_error');
	}

	if (response.status >= 500) {
		console.error(TAG, 'server_error', response.status);
		throw new Error('server_error');
	}

	const rawText = await response.clone().text();

	if (!rawText) {
		return null as unknown as T;
	}

	try {
		return JSON.parse(rawText) as T;
	} catch (e) {
		console.error(TAG, 'invalid_response', e, 'body was:', rawText);
		throw new Error('invalid_response');
	}
}

export const submit = (body: SubmitRequest): Promise<SubmitResponse> => request<SubmitResponse>('submit', body);
export const confirm = (body: ConfirmRequest): Promise<ConfirmResponse> => request<ConfirmResponse>('confirm', body);
